/**
 * Utility functions for authentication and authorization
 */

/**
 * Check if the user has the required role
 * @param {Object} user - The user object
 * @param {string|string[]} requiredRoles - Required role(s)
 * @returns {boolean} - Whether the user has the required role
 */
export const hasRole = (user, requiredRoles) => {
    if (!user) return false;

    // If requiredRoles is a string, convert it to an array
    const roles = Array.isArray(requiredRoles) ? requiredRoles : [ requiredRoles ];

    // Check if the user's role is in the required roles
    return roles.includes(user.role);
};

/**
 * Check if the user has the required permission
 * @param {Object} user - The user object
 * @param {string|string[]} requiredPermissions - Required permission(s)
 * @returns {boolean} - Whether the user has the required permission
 */
export const hasPermission = (user, requiredPermissions) => {
    if (!user || !user.permissions) return false;

    // If requiredPermissions is a string, convert it to an array
    const permissions = Array.isArray(requiredPermissions)
        ? requiredPermissions
        : [ requiredPermissions ];

    // Check if the user has all the required permissions
    return permissions.every(permission => user.permissions.includes(permission));
};
